import React from "react";
import ButtonBlack from "@shared/uiNew/Button/button_black";
import * as styles from "./Seats.module.scss";

import { seatsData, REGISTER_URL } from "@shared/arrays/support";

export function Seats() {
  return (
    <section className={styles.section}>
      <div className={styles.inner}>
        <div className={styles.card}>
          <div className={styles.content}>
            <h2 className={styles.title}>{seatsData.title}</h2>
            <p className={styles.text}>{seatsData.text}</p>
            <ButtonBlack
              icon="arrow"
              text={seatsData.cta}
              href={REGISTER_URL}
              type="link"
            />
          </div>

          <div className={styles.media}>
            <img
              src={seatsData.image}
              alt={seatsData.imageAlt}
              width={520}
              height={400}
              loading="lazy"
              decoding="async"
            />
          </div>
        </div>
      </div>
    </section>
  );
}

export default Seats;
